module.exports = __webpack_public_path__ + "static/img/logo_011.9f1ec777.png";